// @ts-nocheck
class ViewSizesButton extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addEventListener("click", this.handleClick.bind(this));
    this.handleResize = this.debounce(this.updateOffset.bind(this), 250);
    window.addEventListener("resize", this.handleResize);
  }

  getOffset() {
    const width = window.innerWidth;
    if (width < 768) {
      return 80; // Mobile offset
    } else if (width < 1024) {
      return 100; // Tablet offset
    } else {
      return 120; // Desktop offset
    }
  }

  updateOffset() {
    this.currentOffset = this.getOffset();
  }

  handleClick(event) {
    event.preventDefault();
    const buttonTarget = this.closest(".ud-view-sizes-button");
    if (!buttonTarget) return;

    const selector = buttonTarget.getAttribute("data-target");
    const target = document.querySelector(`.shopify-section[id*="${selector}"]`);

    if (target) {
      const offset = this.getOffset();
      window.scrollTo({
        top: target.offsetTop - offset,
        behavior: "smooth",
      });
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
  }
}

customElements.define("ud-view-sizes-button", ViewSizesButton);
